import {formSettings, FormSettings} from '../../../bps/components/form/formSettings';

formSettings.checkboxIsSwitch = true;
formSettings.remainSignedIn = true;
formSettings.googlePay = {
  basketColor: 'black',
  checkoutColor: 'black',
};

export {formSettings, FormSettings};
